import { useState, useEffect } from 'react';

const useFirebaseStoresData = (firebase, storeIds) => {
  const [loading, setLoading] = useState(true);
  const [storesWithSoundPermission, setStoresWithSoundPermission] = useState([]);
  const [storesWithNotificationPermission, setStoresWithNotificationPermission] = useState([]);

  useEffect(() => {
    const storeCollection = firebase.collection('salesChannel');
  
    const soundPermissionQuery = storeCollection.where('newPendingOrdersAlertSoundPermission', '==', true);
    const soundPermissionUnsubscribe = soundPermissionQuery.onSnapshot((querySnapshot) => {
        const soundPermissionStores = querySnapshot.docs
          .filter(doc => storeIds.includes(doc.id))
          .map(doc => doc.id);
        setStoresWithSoundPermission(soundPermissionStores);
    });

    const notificationPermissionQuery = storeCollection.where('newPendingOrdersAlertPermission', '==', true);
    const notificationPermissionUnsubscribe = notificationPermissionQuery.onSnapshot((querySnapshot) => {
        const notificationPermissionStores = querySnapshot.docs
          .filter(doc => storeIds.includes(doc.id))
          .map(doc => doc.id);
        setStoresWithNotificationPermission(notificationPermissionStores);
    });

    Promise.all([
      soundPermissionQuery.get(),
      notificationPermissionQuery.get()
    ]).then(() => {
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });

    return () => {
      soundPermissionUnsubscribe();
      notificationPermissionUnsubscribe();
    };
  }, []);

  return { storesWithSoundPermission, storesWithNotificationPermission, loading };
}

export default useFirebaseStoresData